export const DEFAULT_NOTIFICATIONS_CHANNELS = [
    'web3',
    'telegram',
    'sms',
    'email',
];
//# sourceMappingURL=constants.js.map